module.exports = __webpack_public_path__ + "static/media/layout-7.4ae5e5f2.svg";